import { Component, OnInit } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { WebSiteService } from '../services/website-service';
import { Router, ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
    selector: 'm-show-page',
    templateUrl: './show-page.component.html'
})
export class ShowPageComponent implements OnInit {
    page: any;
    image: any;
    url: string;

    constructor(
        public service: WebSiteService,
        private router: Router,
        private activeRouter: ActivatedRoute,
        private cd: ChangeDetectorRef,
        public sanitization: DomSanitizer
    ) {
        this.activeRouter.params.subscribe(params => {
            this.url = params['id'];
            this.getPageContent(this.url);
        });
    }

    ngOnInit(): void {

    }

    getPageContent(url): any {
        this.service.getPage(url).subscribe(res => {
            this.page = res;
            this.page.pageDetails = this.sortList(this.page.pageDetails);
            this.cd.detectChanges();
        });
    }

    public sortList(list: any[]): any {
        return list.sort(function (a, b) {
            return a.priority - b.priority;
        });
    }

}
